import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListFileCategoriesPathParameters } from 'api/actions/hr-list-file-categories/hr-list-file-categories-path-parameters';
import { HrListFileCategoriesResponse } from 'api/actions/hr-list-file-categories/hr-list-file-categories-response';

type HrListFileCategoriesQueryParameters = Record<string, any>;

/**
 * The path of the HrListFileCategories action.
 */
export const hrListFileCategoriesActionPath = new SweetPath<keyof HrListFileCategoriesPathParameters>(
  '/api/hr/file-categories',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrListFileCategories actions.
 */
export default function createHrListFileCategoriesAction(axios: AxiosInstance) {
  return function hrListFileCategoriesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HrListFileCategoriesQueryParameters } = {}) {
    const path = hrListFileCategoriesActionPath.original;

    return axios.request<HrListFileCategoriesResponse, HrListFileCategoriesResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
